export enum DocumentType {
  CPF = 'CPF',
  RG = 'Registro de Identidade',
  CERTIDAO_DE_NASCIMENTO = 'Certidão de Nascimento',
  LAUDO_MEDICO = 'Laudo Médico',
  CONTA_DE_LUZ = 'Conta de Luz',
  CONTA_DE_AGUA = 'Conta de Água',
  CONTA_DE_TELEFONE = 'Conta de Telefone',
  CTPS = 'Carteira de Trabalho',
  EXTRATO_PLANO_SAUDE = 'Extrato de Plano de Saúde',
  EXTRATO_CARTAO_DE_CREDITO = 'Extrato de Cartão de Crédito',
  EXTRATO_DE_IMPOSTO_DE_RENDA = 'Extrato de Imposto de Renda',
  COMPROVANTE_DE_ISENCAO_DE_IPTU = 'Comprovante de Isenção de IPTU',
  COMPROVANTE_DE_PAGAMENTO_DE_IPTU = 'Comprovante de Pagamento de IPTU',
  CONTRA_CHEQUES = 'Contra-Cheques',
  EXTRATO_DE_BENEFICIO_SOCIAL = 'Extrato de Benefício Social',
  BOLETIM_DE_OCORRENCIA = 'Boletim de Ocorrência',
  CNH = 'Carteira Nacional de Habilitação',
  FORM = 'Formulário de Solicitação',
  CERTIDAO_DE_CASAMENTO = 'Certidão de Casamento',
}
